import {atomProgressBarSizes, atomProgressBarTypes} from '@s-ui/react-atom-progress-bar'

export const LABEL_POSITION = {
  INSIDE: 'inside',
  OUTSIDE: 'outside'
}
export const INDICATOR_SIZE = {
  MEDIUM: 'medium',
  LARGE: 'large',
  HUGE: 'huge'
}
export const TYPES = atomProgressBarTypes
export const SIZES = atomProgressBarSizes
export const MAX_SCORE = 10
